export default [
    {
        path: "/insurance/qr-codes",
        name: "qr-codes",
        component: () => import("@/views/qrCodes/AppQrCodes"),
    },
    {
        path: "/insurance/qr-code/create",
        name: "qr-code-create",
        component: () => import("@/views/qrCodes/AppQrCodeEdit"),
        meta: {
            navActiveLink: "qr-codes",
        },
    },
    {
        path: "/insurance/qr-code/:id/update",
        name: "qr-code-update",
        component: () => import("@/views/qrCodes/AppQrCodeEdit"),
        meta: {
            navActiveLink: "qr-codes",
        },
    },
];
